import { auth, signInAnonymously } from '@/helpers/firebase'
import { consoleTimeTrack } from '../../../consoleTimeTrack'

export const signInAnonymous = async () => {
  try {
    const startTime = consoleTimeTrack(`connecting anonymously`, {fileName: 'signInAnonymous.jsx', methodName: 'signInAnonymous'})
    await signInAnonymously(auth)
    const newTime = consoleTimeTrack()
    consoleTimeTrack(`signed in anonymously in ${newTime - startTime}ms`, {fileName: 'signInAnonymous.jsx', methodName: 'signInAnonymous'})

  } catch (error) {
    console.warn(emoji, error)
  }
}
